import { CampanhaUsuarioService } from "../../../services/campanhaUsuario/campanhaUsuarioService";
import { CampanhaUsuarioResponse } from "../../../types/campanhaUsuario/campanhaUsuarioResponse";
import { CampanhaPedidoExtratoResponse } from "../../../types/campanhaPedidoExtrato/campanhaPedidoExtratoResponse";
import { AprovarPedidoDetalhesProps } from "../../../views/aprovarPedido/components/aprovarPedidoDetalhes";

export default class AprovarPedidoDetalhesContainer {
  public props: AprovarPedidoDetalhesProps;
  private campanhaUsuarioService: CampanhaUsuarioService;

  constructor(props: AprovarPedidoDetalhesProps) {
    this.props = props;
    this.campanhaUsuarioService = new CampanhaUsuarioService();
  }
  async GetCampanhaUsuario(usuarioId: number, campanhaId: number) : Promise<CampanhaUsuarioResponse> {
    const result = await this.campanhaUsuarioService.GetCampanhaUsuario(usuarioId, campanhaId);
    if (result instanceof Error) {
      throw result;
    }
    return result;
  }

  async GetCampanhaPedidoExtrato(usuarioId: number, campanhaId: number): Promise<CampanhaPedidoExtratoResponse[]> {
    const result = await this.campanhaUsuarioService.GetCampanhaPedidoExtrato(usuarioId, campanhaId);
    if (result instanceof Error) {
      throw result;
    }
    return result;
  }
}

// import { CampanhaComponentProps } from "../../views/campanha/campanha"

// export interface CampanhaContainerProps { }

// export default class CampanhaContainer {
//   public props : CampanhaComponentProps

//   constructor(props : CampanhaComponentProps) {
//     this.props = props
//   }
  
//   public GetExemplo = () => {
//     this.props.GetExemplo()
//   }
// }
